import {formatCurrency, numberFormatter} from "../../../common/Helper/Support/SettingsHelper";
import {TRANSACTIONS} from "../../Config/ApiUrl";
import {dateTimeFormat, getUtcToLocalTimeOnly} from "../../../common/Helper/Support/DateTimeHelper";
import {ucFirst} from "../../../common/Helper/Support/TextHelper";
import NavFilterMixin from "./NavFilterMixin";
import StatusMixin from "../../../common/Mixin/Global/StatusMixin";
import {UserFilterMixin} from "./FilterMixin";

export default {
    mixins: [NavFilterMixin, StatusMixin, UserFilterMixin],
    data() {
        return {
            numberFormatter,
            tableOptions: {
                tableData: 0,
                afterRequestSuccess: ({data}) => {
                    this.tableData = data.data.length;
                },
                name: this.$t('tickin_report'),
                url: TRANSACTIONS,
                showHeader: true,
                enableRowSelect: false,
                showCount: false,
                showClearFilter: false,
                showFilter: false,
                showSearch: false,
                tablePaddingClass: "px-0",
                tableShadow: false,
                managePagination: true,
                datatableWrapper: false,
                filters: [],
                columns: [
                    {
                        title: this.$t('invoice_no'),
                        type: 'custom-html',
                        key: 'invoice_no',
                        isVisible: true,
                        modifier: (val, row) => {
                            return `<p class="pt-1 font-size-90 text-muted">${val}</p>`;
                        }
                    },
                    {
                        title: this.$t('amount'),
                        type: 'custom-html',
                        key: 'amount',
                        isVisible: true,
                        modifier: (val, row) => {
                            return `<p class="pt-1 font-size-90 text-muted">${this.numberFormatter(val)}</p>`;
                        }
                    },
                    {
                        title: this.$t('trx_no'),
                        type: 'custom-html',
                        key: 'trx_no',
                        isVisible: true,
                        modifier: (val, row) => {
                            return this.putIntoSpan(val);
                        }
                    },
                    {
                        title: this.$t('created_at'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (val, row) => {
                            return this.putIntoSpan(dateTimeFormat(val));
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: (status, row) => {
                            return `<div class="d-flex"><span class="mr-2 badge badge-sm badge-pill badge-${status.class}">
                                ${status.translated_name}
                            </span>${parseInt(row.conflicted) ?
                                `<span class="badge badge-sm badge-pill badge-danger">
                                ${this.$t('conflicted')}
                            </span>` : ''}</div>`
                        }
                    },
                    {
                        title: this.$t('employee'),
                        type: 'custom-html',
                        key: 'payable',
                        isVisible: true,
                        modifier: (payable, row) => {
                            return payable ? payable.full_name : '-';
                        }
                    },
                    {
                        title: this.$t('type'),
                        type: 'custom-html',
                        key: 'type',
                        isVisible: true,
                        modifier: (type, row) => {
                            return type ? type : '-';
                        }
                    },
                    {
                        title: this.$t('product'),
                        type: 'custom-html',
                        key: 'meta',
                        isVisible: true,
                        modifier: (row) => {
                            let meta = JSON.parse(row);
                            return meta.product ?? meta.description ?? '';
                        }
                    },
                    // {
                    //     title: this.$t('meta'),
                    //     type: 'object',
                    //     key: 'meta',
                    //     isVisible: true,
                    //     modifier: (meta, row) => {
                    //         return meta ? meta.description : '-';
                    //     }
                    // },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                queryParams: false,
                actions: [
                    // {
                    //     title: this.$t('edit'),
                    //     actionName: 'edit',
                    //     modifier: row => this.$can('update_transactions'),
                    // }
                ],
            },
            options: {
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('status'),
                        type: "multi-select-filter",
                        key: "status",
                        option:[],
                        listValueField: 'translated_name',
                    },
                    {
                        title: this.$t('users'),
                        type: "multi-select-filter",
                        key: "users",
                        option: [],
                        listValueField: 'full_name',
                        permission: !!this.$can('view_users')
                    }
                ],
            },
            periodFilters: [
                {
                    id: 'thisMonth',
                    value: this.$t('this_month')
                },
                {
                    id: 'lastMonth',
                    value: this.$t('last_month')
                },
                {
                    id: 'thisYear',
                    value: this.$t('this_year')
                },
                {
                    id: 'lastYear',
                    value: this.$t('last_year')
                },
                {
                    id: 'total',
                    value: this.$t('total')
                },
            ]
        }
    },
    computed:{
        currencySymbol(){
            return window.settings.currency_symbol;
        }
    },
    methods:{
        putIntoSpan(data){
            return `<span class="min-width-100 d-block">${data}</span>`
        }
    }
}